// Angular Import
import { Component, inject, Input, input, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule, Event } from '@angular/router';
import { Title } from '@angular/platform-browser';

// project import
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { componentMenus } from 'src/app/demo/data/component';
import { Navigation, NavigationItem } from 'src/app/@theme/types/navigation';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { NavRightComponent } from '../../layouts/toolbar/toolbar-right/toolbar-right.component';

import { NavLeftComponent } from '../../layouts/toolbar/toolbar-left/toolbar-left.component';

interface titleType {
  // eslint-disable-next-line
  url: string | boolean | any | undefined;
  title: string;
  breadcrumbs: unknown;
  type: string;
  link: string | undefined;
}

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, SharedModule, NavLeftComponent, NavRightComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  HeaderBlur: boolean;
  private route = inject(Router);
  private titleService = inject(Title);

  datos: any;

  // public props
  @Input() type: string;
  readonly Component = input(false);
  readonly dashboard = input(true);

  navigations: NavigationItem[];
  ComponentNavigations: NavigationItem[];
  breadcrumbList: Array<string> = [];
  navigationList: titleType[];
  componentList: titleType[];
  nombreEmpresa: string = '';
  // constructor
  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    // Obtener el menú desde localStorage
    const storedMenu = localStorage.getItem('menu');
    this.navigations = storedMenu ? JSON.parse(storedMenu) : [];
    this.ComponentNavigations = componentMenus;
    this.type = 'theme1';

    this.setBreadcrumb();
  }

  // public method
  setBreadcrumb() {
    this.route.events.subscribe((router: Event) => {
      if (router instanceof NavigationEnd) {
        let activeLink = router.url;

        // if (activeLink == '/empresasPagar') {
        //   activeLink = '/dashboard/dashboardTrueque';
        // }

        const breadcrumbList = this.filterNavigation(this.navigations, activeLink);

        this.navigationList = breadcrumbList;

        this.componentList = this.filterNavigation(this.ComponentNavigations, activeLink);

        const title = breadcrumbList[breadcrumbList.length - 1]?.title || 'Welcome';
        this.titleService.setTitle(title + ' | BlueOcean');
      }
    });
  }

  goBack(route: string) {
    this.router.navigate([route]); // Redirige a la ruta especificada
  }

  filterNavigation(navItems: NavigationItem[], activeLink: string): titleType[] {
    const userRole = this.getUserRole(); // Aquí obtienes el rol del usuario, por ejemplo, desde un servicio de autenticación

    for (const navItem of navItems) {
      if (!navItem.role || navItem.role.includes(userRole)) {
        if (navItem.type === 'item' && 'url' in navItem && navItem.url === activeLink) {
          return [
            {
              url: navItem.url,
              title: navItem.title,
              link: navItem.link,
              breadcrumbs: navItem.breadcrumbs || true,
              type: navItem.type
            }
          ];
        }

        if ((navItem.type === 'group' || navItem.type === 'collapse') && 'children' in navItem) {
          const breadcrumbList = this.filterNavigation(navItem.children!, activeLink);
          if (breadcrumbList.length > 0) {
            breadcrumbList.unshift({
              url: navItem.url || false,
              title: navItem.title,
              link: navItem.link,
              breadcrumbs: navItem.breadcrumbs || true,
              type: navItem.type
            });
            return breadcrumbList;
          }
        }
      }
    }

    return [];
  }
  getUserRole(): string {
    const role = localStorage.getItem('roleUser'); // Obtiene el rol desde localStorage
    return role || 'User'; // Si no se encuentra, asigna 'User' por defecto
  }
  ngOnInit() {
    const userRole = this.getUserRole(); // Obtén el rol del usuario
    const userRaw = localStorage.getItem('currentUser');
    if (userRaw) {
      try {
        const user = JSON.parse(userRaw);
        this.nombreEmpresa = user.datos_empresa?.razonSocial || 'Empresa desconocida';
      } catch (e) {
        console.error('Error al parsear el usuario del localStorage:', e);
      }
    }
    // Filtra los menús según el rol del usuario
    this.navigations = this.navigations.filter((item) => item.role.includes(userRole));

    // Si tienes sub-menús, también deberías filtrarlos
    this.navigations.forEach((item) => {
      if (item.children) {
        // Filtramos los hijos basados en el rol

        item.children = item.children.filter((child) => {
          if (child.children) {
            child.children = child.children.filter((subChild) => subChild.role.includes(userRole));
          }

          return child.role.includes(userRole); // Devuelve si el rol está incluido
        });

        // Si después de filtrar no hay hijos que coincidan con el rol, eliminamos la propiedad children
        if (item.children.length === 0) {
          delete item.children;
        }
      }
    });
  }
}
